function openDrawer(id, drawerClass) {
    const drawers = document.querySelectorAll('.ss-drawer');
    drawers.forEach(d => d.classList.remove('is-open'));

    document.body.classList.add(drawerClass);

    const target = document.getElementById(id);
    if(target) target.classList.add('is-open');
}

function closeAllDrawers() {
    document.body.classList.remove('ss-drawer-active');
    document.body.classList.remove('abs-drawer-active');
    const drawers = document.querySelectorAll('.ss-drawer');
    drawers.forEach(d => d.classList.remove('is-open'));
}

document.addEventListener('keydown', function(event) {
    if (event.key === "Escape") {
        closeAllDrawers();
    }
});

document.addEventListener('DOMContentLoaded', function() {
    const modal = document.getElementById('facts-modal');
    const modalImg = document.getElementById('modal-fact-image');
    const closeBtn = document.getElementById('close-modal');
    const ctaButtons = document.querySelectorAll('.ss-cta');

    // Open Modal
    ctaButtons.forEach(button => {
        button.addEventListener('click', function(e) {
        e.preventDefault();
        const imageUrl = this.getAttribute('data-facts');
        
        if (imageUrl) {
            modalImg.src = imageUrl;
            // Add the class to trigger CSS animations
            modal.classList.add('is-open');
            document.body.style.overflow = 'hidden';
        }
        });
    });

    // Close function
    function closeModal() {
        modal.classList.remove('is-open');
        document.body.style.overflow = '';
        // Optional: Clear image after animation finishes (300ms)
        setTimeout(() => { modalImg.src = ''; }, 300);
    }

    closeBtn.addEventListener('click', closeModal);

    modal.addEventListener('click', function(e) {
        if (e.target === modal) closeModal();
    });

    const overlay = document.getElementById('ss-drawer-overlay');
    const overlayAbs = document.getElementById('abs-drawer-overlay');
    if (overlay) {
        overlay.addEventListener('click', function (e) {
        // Only close if user clicked the overlay itself, not the drawer
        if (e.target === overlay) {
            closeAllDrawers();
        }
        });
    }

    if (overlayAbs) {
        overlayAbs.addEventListener('click', function (e) {
        // Only close if user clicked the overlay itself, not the drawer
        if (e.target === overlayAbs) {
            closeAllDrawers();
        }
        });
    }

});